import { render, staticRenderFns } from "./OrderCus.vue?vue&type=template&id=c9d199f4"
import script from "./OrderCus.vue?vue&type=script&lang=js"
export * from "./OrderCus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports